import React from 'react'

import img1 from './img/orzel1.jpg'
import img2 from './img/orzel2.jpg'
import img3 from './img/orzel3.jpg'

function opisWisla() {
  return (
    <div className='opis-container'>
      <div className='opis-header'>
        
        <h1>Grębałowianka - Orzeł Piaski Wielkie</h1> 
        
       
      </div>

      <div className='opis-info'>
          <p>
          9 kolejka I ligi oldboyów Kraków <br></br>

Grębałowianka Kraków -Orzeł Piaski Wielkie 1:0 (0:0) <br></br>
Bramka dla Gręby -Lampart 8 min doliczonego czasu gry !!!!! <br></br>

Skład Grębałowianki: Kokosza/ Nowak - Korcala, Rutka Ochlust, Talaga,Wierzbinski, Oleś, Cecuga, Mucharski, Lampart, Strojek R, Grzywa, Karaś, Zięba, Gadzina  <br></br>

Trener Bernard Łach  <br></br>
Catering Marcin Stolarski <br></br>
Jurek Ostrowski  <br></br>

 Po sobotnich emocjach charytatywnych już w poniedziałek przystąpiliśmy do arcy ważnego meczu o punkty a przeciwnikiem sąsiad w tabeli drużyna Orła Piaski Wielkie. Mecz który był bardzo wyrównany z lekką przewagą gospodarzy. Okazji bramkowych było sporo Mucharski, Strojek R, Karaś,Ochlust,Grzywa,Gadzina- (to debiut w drużynie 👋) Lampart. Niestety piłka jak zaczarowana nie chciała wpaść do bramki gości. Emocji meczowych było dużo jak również żółtych kartek (5 min.) i również 1 czerwona dla zawodnika Orła. Doliczony czas gry przez sędziego 5 min napór Gręby. Sędzia znowu dolicza jeszcze 3 min z tytułu przerw i po zamieszaniu bramkowym Lampart w 8 min doliczonego czasu gry zdobywa płaskim strzałem koło słupka decydującą bramkę o zwycięstwie Grębałowianki. Super strzał bardzo ważne 3 pkt w obliczu naszej tabeli. 
Łukasz Lampart ta finalną bramkę dedykuję swojej mamie 👏😉⚽ Pozdrawiamy 😉
Już w poniedziałek 17.06. ostatni mecz rundy wiosennej a przeciwnikiem Opatkowianka. Mecz rozgrywany w Skotnikach na sztucznej o godz. 21:00.Tabela i wyniki poniżej.
Pozdrawiam Piotr Grzywa 😉👌⚽
          
          </p>

        <img src={img1} alt='gre-dab'></img>
        <img src={img2} alt='gre-dab'></img>
        <img src={img3} alt='gre-dab'></img>
        
       
      </div>
        
        </div>
  )
}

export default opisWisla